
import React, { useState } from 'react';
import { Menu, X, User, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useDashboard } from '@/hooks/useDashboard';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const DashboardNav: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { userData, handleSignOut, setIsProfileOpen } = useDashboard();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleOpenProfile = () => {
    setIsProfileOpen(true);
  };

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container-wide flex justify-between items-center py-4">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <img 
              src="/lovable-uploads/d026ae3d-a0b1-4433-b6a9-510b03ec97d4.png" 
              alt="IT Management Solutions Logo" 
              className="h-10"
            />
          </Link>
        </div>

        {/* Desktop Controls */}
        <div className="hidden md:flex items-center space-x-4">
          <p className="text-itmgmt-dark-blue font-medium">
            Welcome back, {userData?.full_name || 'Client'}
          </p>
          
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="text-itmgmt-dark-blue border-itmgmt-dark-blue hover:bg-itmgmt-medium-blue/10">
                <User className="mr-2 h-4 w-4" />
                Account
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuItem onClick={handleOpenProfile}>
                <Settings className="mr-2 h-4 w-4" />
                Account Settings
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={handleSignOut}>
                Log Out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center space-x-4">
          <p className="text-itmgmt-dark-blue text-sm font-medium">
            Welcome, {userData?.full_name || 'Client'}
          </p>
          <button onClick={toggleMenu} className="text-itmgmt-dark-blue">
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white py-4 shadow-lg">
          <div className="container-wide flex flex-col space-y-4">
            <Button 
              variant="ghost" 
              className="text-itmgmt-dark-blue hover:bg-itmgmt-medium-blue/10 w-full text-left justify-start"
              onClick={handleOpenProfile}
            >
              <Settings className="mr-2 h-4 w-4" />
              Account Settings
            </Button>
            <Button 
              variant="ghost" 
              className="text-itmgmt-dark-blue hover:bg-itmgmt-medium-blue/10 w-full text-left justify-start"
              onClick={handleSignOut}
            >
              Log Out
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default DashboardNav;
